import { expVal } from '@confluence/feature-experiments';

let store: any | null = null;

function getStore() {
	const AsyncLocalStorage = (globalThis as any)?.__vm_internals__?.asyncLocalStorage
		?.AsyncLocalStorage;

	if (!AsyncLocalStorage || !expVal('block_network_requests_from_rendering', 'isEnabled', false)) {
		return null;
	}
	if (!store) {
		store = new AsyncLocalStorage();
	}
	return store;
}

export function runInQueryBoundary(name: string, callback: () => void) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const store = getStore();
		if (!store) {
			return callback();
		}
		return store.run(name, callback);
	} else {
		return callback();
	}
}

export function getQueryBoundary() {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const store = getStore();
		if (!store) {
			return null;
		}
		return store.getStore();
	} else {
		return null;
	}
}

/**
 * Tracks queries that have been fired within a valid query boundary.
 * When a query is first fired from a preloader (with a boundary), it is recorded here.
 * If the same query is later fired from a React component (without a boundary),
 * it will still be allowed because it was previously authorized.
 */
const boundaryAuthorizedQueries = new Set<string>();

/**
 * If called within a query boundary, marks the query as authorized and returns true.
 * If called outside a boundary, returns true only if the query was previously authorized.
 */
export function checkQueryAuthorizedByBoundary(operationName: string, variables: any): boolean {
	const key = `${operationName}:${JSON.stringify(variables)}`;
	if (boundaryAuthorizedQueries.has(key)) {
		return true;
	}
	if (getQueryBoundary()) {
		boundaryAuthorizedQueries.add(key);
		return true;
	}
	return false;
}

export function clearBoundaryAuthorizedQueries() {
	boundaryAuthorizedQueries.clear();
}
